import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vvh7uweja: FaireProductEntity = {
  token: "p_7vvh7uweja",
  type: "product",
  name: "JV Little Colored Pencil Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ab625987e0271676e981f45be22137a950d28a6798c31c32303b0f84eb15a77f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4dbce24829ac78103e2c806f34e3c2f044624668841fd79c7b2824ebcfd826b.jpeg",
  ],
  priceDollars: 8,
  description:
    "Maybe it’s the stripes, maybe it’s the little tube they come in, or maybe it’s the free, youthful feeling you get when you color… whatever it is, these are our newest happy-makers! Set of 10 colored pencils in perfect, vibrant shades, tucked inside an adorable little tube that slides open in the most satisfying way. Perfect for adding colorful little drawings to your Little Notes®!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:09.289Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
